import proptypes from 'prop-types';

const {
  arrayOf, func, number, shape, string
} = proptypes;

export const ListViewPropTypes = {
  collection: shape({
    descriptors: arrayOf(shape({})),
    details: shape({}),
    metadata: shape({
      baseUrl: string,
      brandName: string,
      canonicalUrl: string,
      name: string,
      pageSize: number,
      productCount: shape({
        allProducts: string,
        inStore: string
      }),
      roomType: string,
      startIndex: number
    }),
    products: arrayOf(shape({})),
    taxonomy: shape({})
  }).isRequired,
  collectionId: string.isRequired,
  storeId: string.isRequired,
  skipFn: func.isRequired
};
